import { TrackingMethod, TrackingProvider } from '../../../../../domain/Tracking'

export function formatFinalizeConnectionButtonText({
  method,
  provider,
  hasErrorUpdate,
  hasPreviousTracking,
}: {
  method?: TrackingMethod
  provider?: TrackingProvider
  hasErrorUpdate?: boolean
  hasPreviousTracking: boolean
}) {
  if (hasErrorUpdate) return 'We could not save, please try again'
  if (hasPreviousTracking) return 'Confirm tracking setup'

  switch (method) {
    case TrackingMethod.ELD:
      if (provider === TrackingProvider.MACROPOINT) return 'Confirm and open Macropoint'
      if (provider === TrackingProvider.TT) return 'Confirm and open Trucker Tools'
      return 'Confirm and open'
    case TrackingMethod.API:
      if (provider === TrackingProvider.MACROPOINT) return 'Confirm and open Macropoint'
      return 'Confirm and send API request'
    case TrackingMethod.EDI:
      return 'Confirm and send request'
    case TrackingMethod.Mobile:
      if (provider === TrackingProvider.MACROPOINT) return 'Send app download link to driver'
      return 'Confirm tracking setup'
    case TrackingMethod.Manual:
      return 'Confirm tracking setup'
  }
}

export function formatFinalizeConnectionStepTitle(hasPreviousTracking: boolean) {
  return hasPreviousTracking ? '3. Confirm preferred method' : '3. Finalize connection'
}

export function formatFinalizeConnectionStepSubtitle(hasPreviousTracking: boolean) {
  return hasPreviousTracking
    ? 'Review and confirm the tracking setup'
    : 'Confirm and finalize the tracking connection'
}
